import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './style.css';
import '@/styles/globals.css'
import { ConfigProvider } from './Experience/Utils/ConfigContext';

const appContainer = document.getElementById('app');

const root = createRoot(appContainer);
root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);